import React from 'react'
import { motion } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import {Check, X} from 'lucide-react'

const ForWho = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  })

  const forWho = [
    'Para quem já tentou aprender inglês antes',
    'Para quem quer constância, não milagres',
    'Para quem prefere estrutura a motivação passageira',
  ]

  const notForWho = [
    'Para quem busca resultado instantâneo',
    'Para quem não quer se comprometer com o processo',
  ]

  return (
    <section ref={ref} className="py-20 md:py-32 bg-gradient-to-b from-gray-50 to-white relative overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8 }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-gray-900 mb-6 leading-tight">
              Para quem é{' '}
              <span className="text-gray-400">(e para quem não é)</span>
            </h2>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-8">
            {/* For Who */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={inView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-3xl p-8 md:p-10 border-2 border-green-200 hover:border-green-400 transition-colors duration-300"
            >
              <div className="flex items-center gap-3 mb-8">
                <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
                  <Check className="w-6 h-6 text-white" strokeWidth={3} />
                </div>
                <h3 className="text-3xl font-black text-gray-900">Para quem é</h3>
              </div>

              <div className="space-y-5">
                {forWho.map((item, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, x: -20 }}
                    animate={inView ? { opacity: 1, x: 0 } : {}}
                    transition={{ duration: 0.5, delay: 0.4 + index * 0.1 }}
                    whileHover={{ x: 5 }}
                    className="flex items-start gap-4 bg-white rounded-xl p-5 shadow-sm hover:shadow-md transition-all duration-300"
                  >
                    <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                      <Check className="w-4 h-4 text-white" strokeWidth={3} />
                    </div>
                    <p className="text-lg text-gray-800 font-medium leading-relaxed">
                      {item}
                    </p>
                  </motion.div>
                ))}
              </div>
            </motion.div>

            {/* Not For Who */}
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={inView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="bg-gradient-to-br from-red-50 to-orange-50 rounded-3xl p-8 md:p-10 border-2 border-red-200 hover:border-red-400 transition-colors duration-300"
            >
              <div className="flex items-center gap-3 mb-8">
                <div className="w-12 h-12 bg-red-500 rounded-full flex items-center justify-center">
                  <X className="w-6 h-6 text-white" strokeWidth={3} />
                </div>
                <h3 className="text-3xl font-black text-gray-900">Para quem não é</h3>
              </div>

              <div className="space-y-5">
                {notForWho.map((item, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, x: 20 }}
                    animate={inView ? { opacity: 1, x: 0 } : {}}
                    transition={{ duration: 0.5, delay: 0.4 + index * 0.1 }}
                    whileHover={{ x: -5 }}
                    className="flex items-start gap-4 bg-white rounded-xl p-5 shadow-sm hover:shadow-md transition-all duration-300"
                  >
                    <div className="w-6 h-6 bg-red-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                      <X className="w-4 h-4 text-white" strokeWidth={3} />
                    </div>
                    <p className="text-lg text-gray-800 font-medium leading-relaxed">
                      {item}
                    </p>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          </div>

          {/* Bottom statement */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.8 }}
            className="mt-12 text-center"
          >
            <p className="text-xl md:text-2xl text-gray-600 leading-relaxed">
              O EW Pass é para quem entende que{' '}
              <span className="font-bold text-gray-900">
                inglês não se aprende em 30 dias
              </span>
              ,<br className="hidden md:block" />
              mas com <span className="font-bold text-[#0D7FA3]">estrutura e constância</span>, os resultados aparecem.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  )
}

export default ForWho
